(() => {
  'use strict';
  const clean = (value, limit = 200) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, limit);
  const quantity = value => /^\d{1,4}$/.test(String(value)) && Number(value) > 0 ? String(Number(value)) : '1';
  const height = value => String(value || '').match(/\b(36|42|48)\b/)?.[1] || '';
  const finish = value => /matte[ -]?black/i.test(value) ? 'Matte Black' : /brushed|stainless/i.test(value) ? 'Brushed Stainless' : '';

  document.querySelectorAll('[data-product-quote]').forEach(link => {
    const scope = link.closest('.product-info');
    const form = scope?.querySelector('form[action*="/cart/add"]');
    const data = scope?.querySelector('[data-product-variants]');
    if (!form || !data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch { return; }
    if (!Array.isArray(variants)) return;
    const update = () => {
      const selected = variants.find(variant => String(variant.id) === form.querySelector('[name="id"]')?.value);
      if (!selected) return;
      const params = new URLSearchParams({
        product: clean(link.dataset.productTitle),
        variant: clean(selected.title),
        variant_id: String(selected.id),
        quantity: quantity(form.querySelector('[name="quantity"]')?.value),
        product_url: link.dataset.productUrl
      });
      // Option strings preserve the selected finish and height without relying on their order.
      const options = (selected.options || []).join(' / ');
      if (height(options)) params.set('height', height(options));
      if (finish(options)) params.set('finish', finish(options));
      link.href = '/pages/quote?' + params.toString() + '#quote-form';
    };
    ['click', 'input', 'change'].forEach(event => form.addEventListener(event, () => queueMicrotask(update)));
    link.addEventListener('click', update);
    update();
  });

  const form = document.getElementById('quote-form-page');
  const context = form?.querySelector('[data-quote-context]');
  if (!context) return;
  const params = new URLSearchParams(window.location.search);
  const product = clean(params.get('product'));
  const variant = clean(params.get('variant'));
  const count = quantity(params.get('quantity'));
  if (product) {
    const detail = form.querySelector('[data-quote-context-details]');
    detail.textContent = [product, variant && variant !== 'Default Title' ? variant : '', 'Quantity: ' + count].filter(Boolean).join(' · ');
    const addField = (name, value) => {
      if (!value) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + name + ']';
      input.value = value;
      context.append(input);
    };
    addField('selected_product', product);
    addField('selected_variant', variant);
    addField('selected_quantity', count);
    const id = params.get('variant_id') || '';
    if (/^\d{1,20}$/.test(id)) addField('selected_variant_id', id);
    const path = clean(params.get('product_url'), 250);
    if (/^\/products\/[a-z0-9][a-z0-9-]*$/.test(path)) addField('selected_product_url', path);
    context.hidden = false;
  }
  // Keep a shopper's restored or rejected form values intact.
  if (form.querySelector('[data-quote-errors]')) return;
  const fill = (id, value) => {
    const field = form.querySelector('#' + id);
    if (field && !field.value && value) field.value = value;
  };
  const selectedHeight = height(params.get('height'));
  fill('qf-height', selectedHeight ? selectedHeight + ' inches' : '');
  fill('qf-finish', finish(params.get('finish') || ''));
  // Calculator links provide length. Kits can also supply an editable estimate.
  const suppliedLength = params.get('length');
  const kitLength = product.match(/^(\d+(?:\.\d+)?)\s*ft\b.*\bkit\b/i);
  const length = suppliedLength || (kitLength ? Number(kitLength[1]) * Number(count) : '');
  if (/^\d+(?:\.\d+)?$/.test(String(length)) && Number(length) >= 1 && Number(length) <= 100000) {
    fill('qf-length', String(Number(length)));
  }
})();
